<template>
  <li class="card relative nav-card bg-gray-02 p-[.75rem] flex flex-col justify-between items-start" role="none">
    <a
      :href="composeLink(navItemData.url)"
      class="cover-link font-heading font-bold slide text-lg nav__menu-item"
      tabindex="-1"
      role="menuitem"
      :qaid="`${navItemData.uid}-card`"
      @keydown.prevent.right="rightFunction"
      @keydown.prevent.left="leftFunction"
      @keydown.prevent.down="downFunction"
      @keydown.prevent.up="upFunction"
    >
      <span v-html="navItemData.linkName"></span>
    </a>
    <picture class="aspect-[11/6] px-4 w-full block">
      <img
        :data-nav-image="imageAsset"
        class="object-contain h-full w-full"
        loading="lazy"
        :alt="navItemData.linkName"
      />
    </picture>
  </li>
</template>
<script>
import {Cloudinary, CloudinaryConstants} from '@/utils/image/cloudinary-helpers.js';
import links from '@/navigation/mixins/links.js';
export default {
  name: 'NavBikeFamilyCard',
  mixins: [links],
  props: {
    navItemData: {
      type: Object,
      default: () => ({}),
    },
    rightFunction: {
      type: Function,
      default: () => {},
    },
    leftFunction: {
      type: Function,
      default: () => {},
    },
    upFunction: {
      type: Function,
      default: () => {},
    },
    downFunction: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    imageAsset() {
      const imageTransforms = {
        q: 'auto',
        w: 406,
        dpr: `${window.devicePixelRatio}`,
        ...CloudinaryConstants.DEFAULT_PARAMETERS,
      };
      return this.navItemData.linkAssetID
        ? Cloudinary.createAssetUrl(this.navItemData.linkAssetID, imageTransforms)
        : '';
    },
    altText() {
      return this.navItemData.linkName;
    },
  },
};
</script>
<style lang="scss" scoped>
.cover-link {
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10;
    box-shadow: 0 4px 6px -2px rgb(0 0 0 / 0), 0 10px 15px -3px rgb(0 0 0 / 0);
    transition: box-shadow var(--nav-reduced-motion, 0.24s) ease;
  }

  @media (hover: hover) {
    &:hover {
      &::after {
        box-shadow: 0 4px 6px -2px rgb(0 0 0 /0.05), 0 10px 15px -3px rgb(0 0 0 /0.1);
      }

      &.slide ~ picture img {
        translate: 0.25rem;
      }
    }
  }
}

picture img {
  translate: -0.5rem;
}

.slide ~ picture img {
  transition: translate var(--nav-reduced-motion, 0.185s) cubic-bezier(0.5, 0, 0.25, 1);
}
</style>
